// Hosted-field keys we render, in on-screen order, with customer-facing names
export const CARD_FIELDS = [
  { key: 'number', label: 'card number', error: 'Card number is invalid' },
  { key: 'expirationDate', label: 'expiration date', error: 'Expiration date is invalid' },
  { key: 'cvv', label: 'security code', error: 'Security code is invalid' }
]

const ORDER = CARD_FIELDS.map((field) => field.key)

// Invalid keys from Braintree, restricted to our fields, in on-screen order
export const orderedInvalidFields = (keys) =>
  ORDER.filter((key) => Array.isArray(keys) && keys.includes(key))

// "Please check your expiration date." / "… card number and security code."
export const cardFieldsSummary = (keys) => {
  const labels = orderedInvalidFields(keys).map(
    (key) => CARD_FIELDS.find((field) => field.key === key).label
  )
  if (!labels.length) return ''
  const list =
    labels.length === 1
      ? labels[0]
      : `${labels.slice(0, -1).join(', ')} and ${labels[labels.length - 1]}`
  return `Please check your ${list}.`
}
